import { IGetBancosPagamentoDropDownUseCase } from "../../../presentation/useCases/read/get_bancos_pagamento_dropdown_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetDropDownUseCase
 */

export class GetBancosPagamentoDropDownUseCase implements IGetBancosPagamentoDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getBancosPagamentoDropDown(): Promise<DropDown[]> {
    const response = await this.repository.getBancosPagamentoDropDown();
    return response
  }
}